module.exports = __webpack_public_path__ + "static/media/features_cajas-sin-costo.99ecf8fd.jpg";